import Page from "webPage/Page";
import CanvasImage from "CanvasImage";
import Gallery from "base/Gallery";
import ScrollMagic from "scrollmagic";
import "scrollmagic/scrollmagic/minified/plugins/animation.gsap.min";
import {animation, Power0, TimelineMax, TweenMax} from "gsap";

let gallery;

Page.register("/", function () {

    projectHeight();
    $(window).on('resize', projectHeight);

    gallery = new Gallery($(".js-projects"), {
        itemClass: 'project',
        pipClass: 'projects__pag-btn',
        navigateClass: 'project__btn',
        pipsClass: 'projects__pag',
        itemsClass: 'projects__wrap',
        animationDuration: 650
    });

    let parallaxController;
    let storyParallax;
    let heroScene;
    let storiesScene;
    let introParallax;
    let initTimeout;

    function initScrollMagic() {
        if($(window).outerWidth() < 960) return;

        parallaxController = new ScrollMagic.Controller();

        introParallax = new TimelineMax()
            .add([
                TweenMax.fromTo('.js-what-we-do-text', 1, {yPercent: 5}, {yPercent: -25}),
                TweenMax.fromTo('.js-what-we-do-image', 1, {yPercent: 0}, {yPercent: 10})
            ]);

        storyParallax = new TimelineMax()
            .add([
                TweenMax.fromTo('.js-stories-text', 1, {yPercent: 5}, {yPercent: -30}),
                TweenMax.fromTo('.js-stories-image', 1, {yPercent: -5}, {yPercent: 5})
            ]);

        heroScene = new ScrollMagic.Scene({
            triggerElement: '#hero',
            duration: 5000,
            triggerHook: "onLeave"
        }).setTween(introParallax).addTo(parallaxController);

        storiesScene = new ScrollMagic.Scene({
            triggerElement: '#stories',
            duration: 5000,
            triggerHook: "onEnter"
        }).setTween(storyParallax).addTo(parallaxController);

        parallaxController.update(true);
    }

    function destroyScrollMagic() {
        if (initTimeout) clearTimeout(initTimeout);
        if (!parallaxController) return;

        parallaxController.destroy(true);

        parallaxController = null;
        introParallax = null;
        storyParallax = null;
        heroScene = null;
        storiesScene = null;

        $(".js-stories-image, .js-stories-text, .js-what-we-do-text, .js-what-we-do-image").attr("style", "");
    }

    initScrollMagic();

    $(window).on("resize", () => {
        destroyScrollMagic();
        if (initTimeout) clearTimeout(initTimeout);

        initTimeout = setTimeout(initScrollMagic, 200);
    });

    let masksProcess = {
        0: [
            {
                'url': '/images/png/masks/home/process/home-process-mask--top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/home/process/home-process-mask--bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/home/process/home-process-mask--top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/home/process/home-process-mask--bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        960: [
            {
                'url': '/images/png/masks/home/process/home-process-mask--top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/home/process/home-process-mask--bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        1400: [
            {
                'url': '/images/png/masks/home/process/home-process-mask--top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/home/process/home-process-mask--bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ]
    };

    let maskCasestudy = {
        0: [
            {
                'url': '/images/png/masks/home/casestudy/casestudy-mask--mobile.png',
                'vPos': 'center'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/home/casestudy/casestudy-mask--tablet.png',
                'vPos': 'center'
            }
        ],
        960: [
            {
                'url': '/images/png/masks/home/casestudy/casestudy-mask--laptop.png',
                'vPos': 'center'
            }
        ],
        1200: [
            {
                'url': '/images/png/masks/home/casestudy/casestudy-mask--desktop.png',
                'vPos': 'center'
            }
        ],
        1400: [
            {
                'url': '/images/png/masks/home/casestudy/casestudy-mask--1920.png',
                'vPos': 'center'
            }
        ]
    };

    new CanvasImage($('.process__background'), masksProcess);

    $('.project__img').each((_, el) => new CanvasImage($(el), maskCasestudy));

    function projectHeight() {
        let height = 0;
        let $wrap = $('.projects__wrap');
        $wrap.css({height: ""});

        $('.js-project').each(function () {
            height = Math.max(height, $(this).outerHeight());
        });

        $wrap.css({height: height + "px"});
    }
});
